<template>
  <div>
    <div v-show="loginStatus === 'loginCompleted'">
      <div v-show="paperSize" class="container" ref="container">
        <div class="flex main-page" :class="{'full-page':showFullPageWidth}" ref="mainPage">
          <div class="main-container">
            <div class="align-center" id="capture" :class="{'is-border':paperSize=='582.67 393.67'}"
            >
              <div
                  class="move-container"
                  :style="{
                  width:`${widthComputed}px`,
                  height:`${heightComputed}px`,
                  backgroundColor:color,
                  backgroundImage: (pattern&&!pattern.includes('magic.payamakapi')) ? 'url(' + require('@/assets/patterns/'+pattern+'.png') + ')' : (patternBase64?`url(${patternBase64})`:'')
                }"
              >
                <MoveableComponent
                    v-for="(widget,i) in widgets"
                    :index="i"
                    :notInPrint="notInPrint"
                    :isPreview="isPreview"
                    :element="widget"
                    :widgetName="widget.widgetName"
                    @changePosition="changePosition"
                    @changeScale="changeScale"
                    @setActiveWidget="setActiveWidget"
                    @deleteWidgetEmit="deleteWidgetEmit"
                    @changeConfig="changeConfig"
                    :key="widget.id"/>
              </div>
            </div>
            <div class="button-handler">
              <el-button @click="print" type="success">دانلود کارت</el-button>
              <el-button @click="save" type="primary" :loading="saveLoading"> ذخیره سازی</el-button>
              <el-button @click="preview" type="warning">
                <span v-if="!isPreview">
                  پیش نمایش
                </span>
                <span v-else>حالت ویرایش
                </span>
              </el-button>
            </div>
          </div>

          <div class="flex-column ">
            <div @click.stop="collapseWidget('size')" class="widget-and-options">
              <div class="widget-content">
                <svg-icon type="mdi" :path="path[2]"></svg-icon>
                <span class="span-text">سایز کارت</span>
              </div>
              <transition name="fadeHeight">
                <div v-if="backgroundCollapse=='size'" class="collapsed">
                  <div @click.stop="setPaperSize('535 778')" class="collapse-item"
                       :class="[paperSize=='535 778'?'active':'']">
                    <span class="span-text">A5</span>
                  </div>
                  <div @click.stop="setPaperSize('778 535')" class="collapse-item"
                       :class="[paperSize=='778 535'?'active':'']">
                    <span class="span-text">A5 افقی</span>
                  </div>
                  <div @click.stop="setPaperSize('393.67 582.67')" class="collapse-item"
                       :class="[paperSize=='393.67 582.67'?'active':'']">
                    <span class="span-text">A6</span>
                  </div>
                  <div @click.stop="setPaperSize('582.67 393.67')" class="collapse-item"
                       :class="[paperSize=='582.67 393.67'?'active':'']">
                    <span class="span-text">A6 افقی</span>
                  </div>
                  <div @click.stop="setPaperSize('307 182')" class="collapse-item"
                       :class="[paperSize=='307 182'?'active':'']">
                    <span class="span-text">ویزیت افقی</span>
                  </div>
                </div>
              </transition>
            </div>
            <div class="widget-and-options">
              <div @click.stop="collapseWidget('background')" class="widget-content">
                <svg-icon type="mdi" :path="path[1]"></svg-icon>
                <span class="span-text">پس زمینه</span>
              </div>
              <transition name="fadeHeight">
                <div v-if="backgroundCollapse=='background'" class="collapsed">
                  <el-popover
                      popper-class="custom-popover"
                      placement="right"
                      v-model="qrColorPicker">

                    <el-color-picker
                        v-model="color"
                        show-alpha
                        :predefine="predefineColors"
                    />
                    <div slot="reference" class="collapse-item">
                      <svg-icon size="20px" type="mdi" :path="path[8]"></svg-icon>
                      <span class="span-text">رنگ</span>
                    </div>

                  </el-popover>

                  <div class="collapse-item" @click="patternDialogVisible = true">
                    <svg-icon size="20px" type="mdi" :path="path[10]"></svg-icon>
                    <span class="span-text">الگو آماده</span>

                  </div>
                  <div class="collapse-item" @click="uploadPatternModal = true">

                    <svg-icon size="20px" type="mdi" :path="path[12]"></svg-icon>
                    <span class="span-text">آپلود تصویر</span>
                  </div>
                </div>
              </transition>

            </div>

            <div class="widget-and-options" @click="addWidget('image')">
              <div class="widget-content">

                <svg-icon type="mdi" :path="path[3]"></svg-icon>
                <span class="span-text">تصویر</span>
              </div>
            </div>
            <div class="widget-and-options" @click="addWidget('text')">
              <div class="widget-content">

                <svg-icon type="mdi" :path="path[0]"></svg-icon>
                <span class="span-text">متن</span>
              </div>
            </div>
            <div class="widget-and-options" @click="purchaseQr">
              <div class="widget-content">
                <svg-icon type="mdi" :path="path[4]"></svg-icon>
                <span class="span-text">QR جدید</span>
              </div>
            </div>
            <div class="widget-and-options" @click="reload">
              <div class="widget-content">

                <svg-icon type="mdi" :path="path[16]"></svg-icon>
                <span class="span-text">Refresh</span>
              </div>
            </div>
            <div class="widget-and-options" @click="toSmsPanel">
              <div class="widget-content">
                <svg-icon type="mdi" :path="path[14]"></svg-icon>
                <span class="span-text">SMS</span>
                <el-tooltip class="item" effect="dark" content="SMS ویرایش اطلاعات"
                            placement="top-start"><i class="el-input__icon el-icon-question sms-tooltip">
                </i></el-tooltip>
              </div>
            </div>
            <div v-if="qrList.length > 1" class="widget-and-options">
              <div class="widget-content" @click.stop="showQrlist">
                <svg-icon type="mdi" :path="path[11]"></svg-icon>
                <span class="span-text">QR لیست</span>
              </div>
            </div>
            <!--          @click="addWidget('image')"-->
            <!--          <div @click.capture="shapesDialogForm = true" class="widget-and-options">-->
            <!--            <div class="widget-content">-->
            <!--              <svg-icon type="mdi" :path="path[5]"></svg-icon>-->
            <!--              <span class="span-text">اشکال</span>-->
            <!--              <el-dialog-->
            <!--                  title="اشکال"-->
            <!--                  :visible.sync="shapesDialogForm"-->
            <!--                  width="60%"-->
            <!--                  center-->
            <!--              >-->

            <!--              </el-dialog>-->
            <!--            </div>-->
            <!--          </div>-->
            <!--          <div v-if="true" class="widget-and-options" @click="addWidget('text')">-->
            <!--            <div class="widget-content">-->
            <!--              <svg-icon type="mdi" :path="path[7]"></svg-icon>-->
            <!--              <span class="span-text">رنگ شکل</span>-->
            <!--            </div>-->
            <!--          </div>-->
            <div @click="deleteWidgets" class="widget-and-options trash">
              <div class="widget-content">
                <svg-icon type="mdi" :path="path[6]"></svg-icon>
                <span class="span-text">پاک کردن</span>
              </div>
            </div>
            <div @click="logout" class="widget-and-options trash">
              <div class="widget-content">
                <svg-icon type="mdi" :path="path[13]"></svg-icon>
                <span class="span-text">خروج</span>
              </div>
            </div>
            <!--                  <el-button icon="el-icon-plus" @click="addWidget('text')" type="primary" circle>متن</el-button>-->
            <!--                  <el-button icon="el-icon-plus" @click="addWidget('image')" type="primary" circle>عکس</el-button>-->
            <!--                  <el-select v-model="paperSize" placeholder="Select">-->
            <!--                    <el-option-->
            <!--                        v-for="item in paperSizeOptions"-->
            <!--                        :key="item.value"-->
            <!--                        :label="item.label"-->
            <!--                        :value="item.value">-->
            <!--                    </el-option>-->
            <!--                  </el-select>-->
            <!--                  <el-button icon="el-icon-delete" @click="deleteWidgets" type="danger" circle>حذف</el-button>-->
          </div>

        </div>
      </div>
      <div v-show="!paperSize" style="margin: auto"></div>
    </div>

    <div v-if="loginStatus !== 'loginCompleted' && loginStatus !== 'createQr'" class="login-container">
      <div class="login-form">
        <span v-if="loginStatus === 'sendMobile'">
        برای ورود شماره تماس وارد کنید
        </span>
        <span v-if="loginStatus === 'sendOtp'">
      کد تایید ارسال شده را وارد نمایید
        </span>
        <div class="form">
          <div class="form-container">
            <div v-if="loginStatus === 'sendMobile'" class="form-input">
              <el-input class="mobile-input" suffix-icon="el-icon-phone" dir="ltr" placeholder="موبایل 09121234567"
                        type="number"
                        @keyup.enter.native="sendMobile"
                        v-model="mobile">
                <!--  <template slot="append">Http://</template>-->
              </el-input>

              <div v-if="mobileErrorMessage" class="error-input">
                {{ mobileErrorMessage }}
              </div>
            </div>
          </div>

          <div v-if="loginStatus === 'sendOtp'" class="otp-container form-input">
            <OtpInput
                :isValid="isCodeValid"
                :digits="6"
                @on-complete="onCompleteHandler"
                @on-changed="onChangedHandler"
                @on-paste="onPasteHandler">
              <template #errorMessage> اشتباه</template>
            </OtpInput>

          </div>
          <div v-if="countDown > 0 && loginStatus === 'sendOtp'" class="otp-code-timer">
            <span>{{ timerMinutes }}:{{ timerSeconds }}</span>
          </div>
          <div @click="resendMobile" v-if="countDown <= 0 && loginStatus === 'sendOtp'" class="opt-code-resend">
            ارسال دوباره کد تایید
          </div>
          <div v-if="loginStatus === 'sendOtp'" @click="loginStatus='sendMobile'" class="opt-code-resend">
            تغییر شماره موبایل
          </div>
        </div>
        <el-button class="login-button" v-if="loginStatus === 'sendMobile'" type="primary" @click="sendMobile"
                   :loading="sendMobileLoading">ورود
        </el-button>
      </div>
    </div>
    <!--    )-->
    <el-dialog
        title="الگو پس زمینه خود را انتخاب کنید"
        :visible.sync="patternDialogVisible"
        center
        class="pattern"
    >
      <div class="pattern-container">
        <div v-for="pattern in patternsOption" :key="pattern" class="pattern-img-container"
             @click="changePatternBackground(pattern)">
          <img :src="require(`@/assets/patterns/${pattern}.png`)"/>
        </div>
      </div>
    </el-dialog>
    <el-dialog
        title="انتخاب کارت موردنظر"
        :visible.sync="qrListModal"
        center
        custom-class="dialog-content"
    >
      <div class="qr-creator-container">
        <div>
          <div class="qr-color-picker qr-list-dir">
            <div class="qr-div-titles">:کارت</div>
            <el-select class="qr-select mobile-input" v-model="qrIdTemp"
                       placeholder="کارت خود را انتخاب کنید">
              <el-option
                  v-for="(qrCard, index) in qrList"
                  :key="index"
                  :value="qrCard.SMSQrId"
                  :label="qrCard.Text"
              >
                <div class="qr-color-div">
                    <span>
                      {{ qrCard.Text }}
                    </span>
                </div>
              </el-option>
            </el-select>
            <div v-if="qrListErrorMessage" class="qr-list-error-message">
              {{ qrListErrorMessage }}
            </div>
          </div>
        </div>
        <div class="qr-buttons" style="marginTop: 12px">
          <el-button class="login-button" type="primary" @click="selectQrList"
                     :loading="sendSelectedQrLoading">
            ثبت
          </el-button>
        </div>
      </div>
    </el-dialog>
    <el-dialog
        title="تصویر پس زمینه خود را بارگذاری کنید"
        :visible.sync="uploadPatternModal"
        center
        class="upload-pattern"
    >
      <UploaderElementUi :is-pattern="true" @uploadedPattern="getUploadedPattern"
                         :image="pattern.includes('magic.payamakapi')?pattern:null"/>
    </el-dialog>
    <div class="trick-qr" v-if="loginStatus === 'createQr'">
      <el-dialog
          title="Qr ساخت"
          :visible="centerDialogVisible"
          center
          custom-class="dialog-content "
      >
        <div class="qr-creator-container">
          <div>
            <div v-if="!qrText" class="qr-title-input">
              <div class="qr-div-titles">
                <el-tooltip class="item" effect="dark" content="در صورت ثبت امکان ویرایش وجود ندارد"
                            placement="top-start"><i class="el-input__icon el-icon-question">
                </i></el-tooltip>
                :فروشگاه
              </div>
              <el-input class="mobile-input" dir="ltr" placeholder="فروشگاه" type="text" v-model="qrTitle">


              </el-input>
              <div v-if="qrTitleErrorMessage" class="qr-title-error-input">
                {{ qrTitleErrorMessage }}
              </div>
            </div>

            <div class="qr-color-picker">
              <div class="qr-div-titles">:Qr رنگ</div>
              <el-select class="qr-select mobile-input" v-model="qrColorValue" placeholder="رنگ خود را انتخاب کنید">
                <el-option
                    v-for="(color, index) in qrColors"
                    :key="index"
                    :value="color.value"
                    :label="color.name"
                >
                  <div class="qr-color-div" :style="{ backgroundColor: color.value }">
                    <span class="qr-color-span">
                      {{ color.name }}
                    </span>
                  </div>
                </el-option>
              </el-select>
              <div v-if="qrColorErrorMessage" :class="['qr-color-error-input', qrText && 'color-without-text']">
                {{ qrColorErrorMessage }}
              </div>
            </div>
            <div class="qr-color-picker">
              <div class="qr-div-titles">:رنگ زمینه</div>
              <el-select class="qr-select mobile-input" v-model="qrBackgroundValue"
                         placeholder="رنگ خود را انتخاب کنید">
                <el-option
                    v-for="(color, index) in qrBackground"
                    :key="index"
                    :value="color.value"
                    :label="color.name"
                >
                  <div class="qr-color-div" :style="{ backgroundColor: color.value }">
                    <span class="qr-color-span">
                      {{ color.name }}
                    </span>
                  </div>
                </el-option>
              </el-select>
              <div v-if="qrBackgroundErrorMessage"
                   :class="['qr-background-error-input', qrText && 'background-without-text']">
                {{ qrBackgroundErrorMessage }}
              </div>
            </div>

            <div class="qr-color-show">
              <div class="qr-background-box"
                   :style="{ backgroundColor: qrShowBackBox }">
                <div class="qr-color-box"
                     :style="{ backgroundColor: qrShowBox }">
                </div>
              </div>

            </div>
          </div>
          <div class="qr-buttons">
            <el-button class="login-button" type="primary" @click="sendQr" :loading="sendQrLoading">
              ثبت
            </el-button>
          </div>
        </div>
      </el-dialog>
    </div>
    <div v-if="loginStatus === 'selectQr'">
      <el-dialog
          title="انتخاب کارت موردنظر"
          :visible="selectDialogVisible"
          center
          custom-class="dialog-content"
      >
        <div class="qr-creator-container">
          <div>
            <div class="qr-color-picker">
              <div class="qr-div-titles">:کارت</div>
              <el-select class="qr-select mobile-input" v-model="qrIdTemp"
                         placeholder="کارت خود را انتخاب کنید">
                <el-option
                    v-for="(qrCard, index) in qrList"
                    :key="index"
                    :value="qrCard.SMSQrId"
                    :label="qrCard.Text"
                >
                  <div class="qr-color-div">
                    <span>
                      {{ qrCard.Text }}
                    </span>
                  </div>
                </el-option>
              </el-select>
              <div v-if="qrListErrorMessage" class="qr-list-error-message">
                {{ qrListErrorMessage }}
              </div>
            </div>
          </div>
          <div class="qr-buttons" style="marginTop: 12px">
            <el-button class="login-button" type="primary" @click="sendSelectedQr" :loading="sendSelectedQrLoading">
              ثبت
            </el-button>
          </div>
        </div>
      </el-dialog>
    </div>
    <div v-if="loginStatus === 'loginCompleted'" class="phone-support-button" @mouseover="mouseOver"
         :class="{'onhover':hoverPhone}"
         @mouseleave="mouseLeave">
      <div class="phone-support-icon">
        <svg-icon type="mdi" :path="path[15]"></svg-icon>
      </div>
      <div class="phone-support-number" v-if="hoverPhone && showText">
        <span><a href="tel:+982141658">021-41658</a></span>
      </div>
    </div>
  </div>

</template>

<script>

import _ from 'lodash';
import MoveableComponent from './components/MoveableComponent';
import html2canvas from 'html2canvas';
import SvgIcon from '@jamescoyle/vue-icon'
import {
  mdiFormatText,
  mdiFormatColorFill,
  mdiImageSizeSelectLarge,
  mdiImageArea,
  mdiQrcode,
  mdiShape,
  mdiTrashCan,
  mdiInvertColors,
  mdiEyedropperVariant,
  mdiArrangeSendToBack,
  mdiWallpaper,
  mdiClipboardListOutline,
  mdiFileUploadOutline,
  mdiLogout,
  mdiMessageProcessing,
  mdiRefresh,
  mdiPhone
} from '@mdi/js';
import OtpInput from "@/components/OtpLogin/OtpInput";
import axios from 'axios';
import {PatternsV} from "@/assets/statics/patternsV";
import {PatternsH} from "@/assets/statics/patternsH";
import UploaderElementUi from "@/components/Widgets/Image/UploaderElementUi";

const baseUrl = 'https://magic.payamakapi.ir/api/v1/quickSMSQR';
const validateMobile = "/validateUser";
const validateOtp = '/validateToken';
const validateQr = '/EditQr'
const insertInfo = '/InsertInfo'
const curentVersion = '2.05'


export default {
  name: 'App',
  data() {
    return {
      widgets: null,
      navi: null,
      hoverPhone: false,
      activeWidgetId: null,
      showText: false,
      notInPrint: false,
      backgroundCollapse: '',
      colorPickerShow: false,
      path: [mdiFormatText, mdiFormatColorFill, mdiImageSizeSelectLarge, mdiImageArea, mdiQrcode, mdiShape, mdiTrashCan, mdiInvertColors, mdiEyedropperVariant, mdiArrangeSendToBack, mdiWallpaper, mdiClipboardListOutline, mdiFileUploadOutline, mdiLogout, mdiMessageProcessing, mdiPhone, mdiRefresh],
      color: '#FFFFFF',
      predefineColors: [
        '#ff4500',
        '#ff8c00',
        '#ffd700',
        '#90ee90',
        '#00ced1',
        '#1e90ff',
        '#c71585',
        'rgba(255, 69, 0, 0.68)',
        'rgb(255, 120, 0)',
        'hsv(51, 100, 98)',
        'hsva(120, 40, 94, 0.5)',
        'hsl(181, 100%, 37%)',
        'hsla(209, 100%, 56%, 0.73)',
        '#c7158577'
      ],
      paperSizeOptions: [
        {
          value: '778 535',  // '21 14.85'
          label: 'A5 افقی'
        },
        {
          value: '535 778', // '14.85 21'
          label: 'A5'
        },
        {
          value: '393.67 582.67', // '10.5 14.85'
          label: 'A6'
        },
        {
          value: '582.67 393.67', // '14.85 10.5'
          label: 'A6 افقی'
        },
        {
          value: '307 182', // '14.85 10.5'
          label: 'ویزیت افقی'
        }
      ],
      paperSize: null,
      mobile: "",
      submitedMobile: "",
      sendMobileLoading: false,
      needRegister: false,
      centerDialogVisible: true,
      selectDialogVisible: true,
      isCodeValid: true,
      mobileErrorMessage: '',
      loginStatus: 'loginCompleted',
      pasted: false,
      countDown: 120,
      qrTitle: '',
      qrColorValue: '',
      sendQrLoading: false,
      qrColorPicker: false,
      mainPageWidth: 0,
      screenWidth: 0,
      qrColors: [{
        name: 'قرمز',
        value: 'rgb(126, 19, 19)'
      },
        {
          name: 'سرمه ای',
          value: 'rgb(17, 50, 107)'
        },
        {
          name: 'یشمی',
          value: 'rgb(5, 56, 40)'
        },
        {
          name: 'مشکی',
          value: 'rgb(0, 0, 0)'
        }],
      qrId: null,
      qrText: false,
      showFullPageWidth: true,
      qrIdTemp: null,
      qrShowBox: '',
      qrShowBackBox: '',
      qrColorErrorMessage: '',
      qrTitleErrorMessage: '',
      qrListErrorMessage: '',
      qrBackgroundErrorMessage: '',
      userId: null,
      qr: '',
      patternDialogVisible: false,
      pattern: '',
      patternBase64: '',
      qrBackground: [{
        name: 'سفید',
        value: 'rgb(255, 255, 255)'
      },
        {
          name: 'صورتی',
          value: 'rgb(243, 218, 218)'
        },
        {
          name: 'طوسی',
          value: 'rgb(236, 236, 236)'
        },
        {
          name: 'آبی',
          value: 'rgb(213, 229, 242)'
        },
        {
          name: 'سبز',
          value: 'rgb(212, 236, 234)'
        }],
      qrBackgroundValue: '',
      qrList: [],
      qrListModal: false,
      sendSelectedQrLoading: false,
      uploadPatternModal: false,
      isPreview: false,
      saveLoading: false
    }
  },
  computed: {
    patternsOption() {
      console.log(this.paperSizeOptions, 'this.paperSizeOptions')
      const findPaperSize = this.paperSizeOptions.find(size => {
        if (this.paperSize !== null && size.value === this.paperSize) {
          return size
        } else {
          if (size.label === 'A5 افقی') {
            return size
          }
        }
      });
      console.log(findPaperSize, 'findPaperSize')
      if (findPaperSize.label.includes('افقی')) {
        return PatternsH().name;
      } else {
        return PatternsV().name;
      }
    },
    heightComputed() {
      if (!this.paperSize) {
        return 0
      }
      return this.paperSize.split(' ')[1]
    },
    widthComputed() {
      if (!this.paperSize) {
        return 0
      }
      return this.paperSize.split(' ')[0]
    },
    timerMinutes() {
      const timer = Math.floor(this.countDown / 60);
      if (timer < 10) {
        return `0${timer}`
      }
      return timer
    },
    timerSeconds() {
      const minutes = Math.floor(this.countDown / 60);
      const timer = this.countDown - minutes * 60;

      if (timer < 10) {
        return `0${timer}`
      }
      return timer
    }
  },
  components: {
    UploaderElementUi,
    OtpInput,
    MoveableComponent,
    SvgIcon
  },
  mounted() {
    if (!localStorage.getItem('Version') || localStorage.getItem('Version') !== curentVersion) {
      localStorage.clear()
      localStorage.setItem('Version', curentVersion)
      setTimeout(() => {
        location.reload();
      }, 100)
    }
    if (JSON.parse(localStorage.getItem('CardData'))?.Widgets) {
      this.widgets = JSON.parse(localStorage.getItem('CardData')).Widgets
    }
    if (JSON.parse(localStorage.getItem('CardData'))?.PaperSize) {
      this.paperSize = JSON.parse(localStorage.getItem('CardData')).PaperSize
    }
    if (JSON.parse(localStorage.getItem('CardData'))?.Pattern) {
      this.pattern = JSON.parse(localStorage.getItem('CardData')).Pattern
    }
    if (JSON.parse(localStorage.getItem('CardData'))?.BackColor) {
      this.color = JSON.parse(localStorage.getItem('CardData')).BackColor
    }
    if (!this.paperSize) {
      this.paperSize = this.paperSizeOptions[0].value
    }
    if (localStorage.getItem('LoginStatus')) {
      this.loginStatus = atob(localStorage.getItem('LoginStatus'))
    } else {
      this.loginStatus = 'sendMobile';
    }
    if (localStorage.getItem('CountDown')) {
      this.countDown = localStorage.getItem('CountDown');
      this.countDownTimer();
    }
    if (localStorage.getItem('QrText')) {
      this.qrText = JSON.parse(localStorage.getItem('QrText'));
    }
    if (JSON.parse(localStorage.getItem('QrList'))?.length) {
      this.qrList = JSON.parse(localStorage.getItem('QrList'));
    }
    this.screenWidth = window.screen.width
    this.navi = navigator.platform
    this.$nextTick(() => {
      let moveables = document.getElementsByClassName('moveable-control-box')
      for (let i = 0; i < moveables.length; i++) {
        moveables[i].style.display = 'none'
      }
    })
    // window.addEventListener("keydown", (event) => {
    //   this.moveKey(event.key)
    // });
  },

  methods: {
    // moveKey(key) {
    //   if (!this.activeWidgetId) return
    //   if (key == 'ArrowRight') {
    //     console.log('moveeee')
    //     let widgets = _.cloneDeep(this.widgets)
    //     let widget = widgets.find(widget => widget.id == this.activeWidgetId)
    //     let transform = _.cloneDeep(widget['transform'])
    //     let splited = transform.split('translate')
    //     console.log(splited[1], 'splited')
    //    let splitedSecond= splited[1].split(',')
    //     console.log(splitedSecond)
    //     // this.changePosition('transform')
    //   }
    // },
    setActiveWidget(id, index) {
      this.activeWidgetId = id
      let moveables = document.getElementsByClassName('moveable-control-box')
      for (let i = 0; i < moveables.length; i++) {
        moveables[i].style.display = 'none'

      }
      if (moveables && moveables.length && moveables[index].style.display == 'none') {
        moveables[index].style.display = 'block'
      }
    },
    mouseLeave() {
      this.hoverPhone = false
      this.showText = false
    },
    mouseOver() {
      this.hoverPhone = true
      setTimeout(() => {
        this.showText = true
      }, 350)
    },
    getUploadedPattern(data) {
      this.pattern = data
      this.uploadPatternModal = false
    },
    changePatternBackground(url) {
      this.pattern = url;
      this.patternDialogVisible = false
    },
    changeScale(value) {
      console.log(value)
      if (value) {

        this.showFullPageWidth = false

      } else {
        this.showFullPageWidth = true
      }

    },
    changePosition(props, value, id) {
      let widgets = _.cloneDeep(this.widgets)
      let widget = widgets.find(widget => widget.id == id)
      widget[props] = value
      this.widgets = widgets
    },
    deleteWidgetEmit(id) {
      let widgets = _.cloneDeep(this.widgets)
      widgets.splice(this.widgets.findIndex((widget) => widget.id == id), 1)
      this.widgets = widgets
    },
    changeConfig(data) {
      let widgets = _.cloneDeep(this.widgets)
      let widget = widgets.find(widget => widget.id == data.id)
      widget.config[data.props] = data.value
      this.widgets = widgets
    },
    preview() {
      this.isPreview = !this.isPreview
    },
    save() {
      this.saveLoading = true;
      // this.mainPageWidth = this.screenWidth
      // this.screenWidth / (this.mainPageWidth + (this.screenWidth / 30))
      axios.post(baseUrl + insertInfo, {
        SMSQrId: localStorage.getItem('QrId'),
        AdditionalInformations: localStorage.getItem('CardData'),
        UserId: localStorage.getItem('UserId')
      }).then(res => {
        if (res.data.Success) {
          this.qrList = res.data.QrList;
          this.$notify.success({
            title: "موفق",
            message: 'اطلاعات شما با موفقیت ذخیره شد',
            offset: 100,
            duration: 3000
          });
        }
      }).finally(() => {
        this.saveLoading = false;
      })
    },
    print() {
      this.notInPrint = true
      var container = document.getElementById("capture");
      if (this.screenWidth < this.mainPageWidth)
        this.mainPageWidth = this.screenWidth * this.screenWidth / (this.mainPageWidth + (this.screenWidth / 30));
      setTimeout(() => {
        let paper0 = parseFloat(this.paperSize.split(' ')[0])
        let paper1 = parseFloat(this.paperSize.split(' ')[1])
        let scale = 3
        if (this.paperSize == '582.67 393.67') {
          paper0 += 41
          paper1 += 47
        }
        if (this.paperSize == '307 182') {
          scale = 5
        }
        html2canvas(container, {
          width: (paper0),
          height: (paper1),
          scale,
        }).then(function (canvas) {
          var link = document.createElement("a");
          document.body.appendChild(link);
          link.download = "Card.jpg";
          link.href = canvas.toDataURL();
          link.target = '_blank';
          link.click();
        })
        setTimeout(() => {
          this.notInPrint = false
          if (this.navi === 'iPhone') {
            setTimeout(() => location.reload(), 7000);
          } else {
            location.reload();
          }
        }, 1000)
      }, 10);
      axios.post(baseUrl + insertInfo, {
        SMSQrId: localStorage.getItem('QrId'),
        AdditionalInformations: localStorage.getItem('CardData'),
        UserId: localStorage.getItem('UserId')
      }).then(res => {
        if (res.data.Success) {
          this.qrList = res.data.QrList
        }
      })
    },
    addWidget(widgetName) {
      if (!this.widgets)
        this.widgets = []
      this.widgets.push({
        widgetName,
        id: parseInt(Math.random() * 10000000),
        width: null,
        height: null,
        transform: null,
        config: {}
      })
    },
    setPaperSize(value) {
      localStorage.setItem('CardData', JSON.stringify({
        ...JSON.parse(localStorage.getItem('CardData')),
        PaperSize: value
      }))
      setTimeout(() => location.reload(), 500);
    },
    deleteWidgets() {
      this.widgets = this.widgets.filter(widget => widget.widgetName === 'qr')
      this.paperSize = this.paperSizeOptions[0].value
      this.color = '#FFFFFF'
      this.pattern = '';
    },
    collapseWidget(props) {
      if (this.backgroundCollapse == props) {
        this.backgroundCollapse = ''
      } else {
        this.backgroundCollapse = props;
      }
      this.colorPickerShow = false;
    },
    onCompleteHandler(code) {
      const userId = this.userId || localStorage.getItem('UserId');
      axios.get(baseUrl + validateOtp + `?code=${code}&userId=${userId}`).then(res => {
        this.pasted = false;
        if (res.data.Success) {
          this.qrList = res.data.QrList;

          if (res.data.QrList.length > 1) {
            this.loginStatus = 'selectQr';
          } else {
            this.qrId = res.data.QrList[0].SMSQrId;
            if (res.data.QrList[0].IsCompleted && res.data.QrList[0].AdditionalInformations) {
              localStorage.setItem('CardData', res.data.QrList[0].AdditionalInformations)
              this.loginStatus = 'loginCompleted';
              setTimeout(() => {
                location.reload()
              }, 100)
            } else {
              if (res.data.QrList[0].IsCompleted) {
                this.qrText = true
              } else {
                this.qrText = false
              }
              this.loginStatus = 'createQr';
            }
          }
          this.$notify.success({
            title: "موفق",
            message: res.data.Message,
            offset: 100,
            duration: 3000
          });
        } else {
          this.$notify.error({
            title: "ناموفق",
            message: res.data.Message,
            offset: 100,
            duration: 3000
          });
        }
      });
      console.log("code completed", code);
      this.isCodeValid = true;
    },
    onChangedHandler(lastEnteredCode) {
      console.log("code changed", lastEnteredCode);
      this.isCodeValid = true;
    },
    onPasteHandler() {
      this.pasted = true;
    },
    submitName() {
      this.needRegister = false;
    },
    sendMobile() {

      if (!this.mobile) {
        this.mobileErrorMessage = "شماره همراه را وارد نکرده اید";
        return;
      }
      var regex = new RegExp("^(\\+98|0)?9\\d{9}$");
      var result = regex.test(this.mobile);
      if (!result) {
        this.mobileErrorMessage = "شماره همراه معتبر نیست";
        return;
      } else {
        this.mobileErrorMessage = "";
      }
      this.sendMobileLoading = true;

      axios.get(baseUrl + validateMobile + `?mobileNumber=${this.mobile}`).then(res => {
        if (res.data.Success) {
          localStorage.setItem('Mobile', this.mobile)
          this.userId = res.data.UserId;
          localStorage.setItem('UserId', res.data.UserId);
          this.countDownTimer();
          this.loginStatus = 'sendOtp';
          this.$notify.success({
            title: "موفق",
            offset: 100,
            message: res.data.Message,
            duration: 3000
          });
        } else {
          this.$notify.error({
            title: "ناموفق",
            message: res.data.Message,
            offset: 100,
            duration: 3000
          });
        }
      }).catch((err) => {
        this.$notify.error({
          title: "ناموفق",
          message: err.data.Message,
          offset: 100,
          duration: 3000
        });
      }).finally(() => {
        this.sendMobileLoading = false;
      })
    },
    resendMobile() {
      const mobile = this.mobile || localStorage.getItem('Mobile');
      this.sendMobileLoading = true;
      if (mobile) {
        axios.get(baseUrl + validateMobile + `?mobileNumber=${mobile}`).then(res => {
          if (res.data.Success) {
            this.countDown = 120;
            this.countDownTimer();
            this.sendMobileLoading = false;
            this.$notify.success({
              title: "موفق",
              message: res.data.Message,
              offset: 100,
              duration: 3000
            });
          } else {
            this.$notify.error({
              title: "ناموفق",
              message: res.data.Message,
              offset: 100,
              duration: 3000,
            });
            this.sendMobileLoading = false;
          }
        });
      }
    },
    countDownTimer() {
      if (this.countDown > 0) {
        setTimeout(
            () => {
              this.countDown -= 1;
              this.countDownTimer();
            },
            1000
        )
      }
    },
    base64ToFile(base64String, fileName, contentType) {
      const byteCharacters = atob(base64String);
      const byteArrays = [];
      const sliceSize = 512;

      for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
        const slice = byteCharacters.slice(offset, offset + sliceSize);

        const byteNumbers = new Array(slice.length);
        for (let i = 0; i < slice.length; i++) {
          byteNumbers[i] = slice.charCodeAt(i);
        }

        const byteArray = new Uint8Array(byteNumbers);
        byteArrays.push(byteArray);
      }

      const blob = new Blob(byteArrays, {type: contentType});
      return new File([blob], fileName, {type: contentType});
    },
    purchaseQr() {
      window.open('https://magicqr.ir/fa/_WeboneOrder/Payment?ProductId=3021974', 'blank')
    },
    sendQr() {
      if (this.qrText ? this.qrBackgroundValue !== '' && this.qrColorValue !== '' : this.qrTitle !== '' && this.qrBackgroundValue !== '' && this.qrColorValue !== '') {
        this.qrTitleErrorMessage = '';
        this.qrColorErrorMessage = '';
        this.qrBackgroundErrorMessage = '';
        this.sendQrLoading = true;
        const colorValue = this.qrColorValue;
        const backgroundValue = this.qrBackgroundValue;
        const validRgb = colorValue.startsWith('rgb') ? colorValue.substring(4, colorValue.length - 1) : colorValue;
        const validRgbBackground = backgroundValue.startsWith('rgb') ? backgroundValue.substring(4, backgroundValue.length - 1) : backgroundValue;
        const validQrId = this.qrId || localStorage.getItem('QrId');

        axios.post(baseUrl + validateQr, {
          SMSQrId: validQrId,
          Text: this.qrTitle,
          UserId: localStorage.getItem('UserId'),
          IsCompleted: JSON.parse(localStorage.getItem('QrList')).find(qrList => {
            if (qrList.SMSQrId == localStorage.getItem('QrId')) {
              return qrList
            }
          }).IsCompleted,
          ReceiverNumber: JSON.parse(localStorage.getItem('QrList')).find(qrList => {
            if (qrList.SMSQrId == localStorage.getItem('QrId')) {
              return qrList
            }
          }).ReceiverNumber,
          QRForColor: validRgb,
          QRBackgroundColor: validRgbBackground
        }).then(res => {
          if (res.data.Success) {
            this.qr = res.data.Qr
            var data = new FormData();
            data.append("file", this.base64ToFile(this.qr, 'my-image.jpg', 'image'));
            axios.post(baseUrl + '/uploadImage', data).then(response => {
              this.widgets = []
              this.widgets.push({
                widgetName: "qr",
                id: parseInt(Math.random() * 10000000),
                width: null,
                height: null,
                transform: null,
                config: {
                  image: response.data.ImageUrl
                }
              })
              this.loginStatus = 'loginCompleted';
              this.sendQrLoading = false;
              this.$notify.success({
                title: "موفق",
                message: res.data.Message,
                offset: 100,
                duration: 3000
              });
              setTimeout(() => {
                location.reload()
              }, 3000)
            })
          } else {
            this.sendQrLoading = false;
            this.$notify.error({
              title: "ناموفق",
              message: res.data.ErrorMessage,
              offset: 100,
              duration: 3000,
            });
          }
        })
      } else {
        if (!this.qrTitle && !this.qrColorValue && !this.qrBackgroundValue) {
          this.qrTitleErrorMessage = 'داشتن متن الزامیست'
          this.qrColorErrorMessage = 'انتخاب رنگ الزامیست'
          this.qrBackgroundErrorMessage = 'انتخاب رنگ الزامیست'
        }
        if (!this.qrTitle) {
          this.qrTitleErrorMessage = 'داشتن متن الزامیست'
        } else {
          this.qrTitleErrorMessage = ''
        }
        if (!this.qrColorValue) {
          this.qrColorErrorMessage = 'انتخاب رنگ الزامیست'
        } else {
          this.qrColorErrorMessage = ''
        }
        if (!this.qrBackgroundValue) {
          this.qrBackgroundErrorMessage = 'انتخاب رنگ الزامیست'
        } else {
          this.qrBackgroundErrorMessage = ''
        }
      }
    },
    sendSelectedQr() {
      if (this.qrIdTemp) {
        this.qrListErrorMessage = ''
        this.qrId = this.qrIdTemp
        let qr = this.qrList.find(qr => qr.SMSQrId == (this.qrId || localStorage.getItem('QrId')))
        if (qr.IsCompleted && qr.AdditionalInformations) {
          this.loginStatus = 'loginCompleted'
          localStorage.setItem('CardData', qr.AdditionalInformations)
          setTimeout(() => {
            location.reload()
          }, 3000)
        } else {
          if (qr.IsCompleted) {
            this.qrText = true
          } else {
            this.qrText = false
          }
          this.loginStatus = 'createQr'
        }
      } else {
        this.qrListErrorMessage = 'انتخاب کارت اجباریست'
      }
    },
    getBase64FromImageUrl(imageUrl) {
      return fetch(imageUrl)
          .then((response) => response.blob())
          .then((blob) => {
            return new Promise((resolve, reject) => {
              const reader = new FileReader();
              reader.onloadend = () => resolve(reader.result);
              reader.onerror = reject;
              reader.readAsDataURL(blob);
            });
          });
    },
    reload() {
      location.reload()
    },
    selectQrList() {
      if (this.qrIdTemp) {
        this.qrListErrorMessage = ''
        this.qrId = this.qrIdTemp
        let qr = this.qrList.find(qr => qr.SMSQrId == (this.qrId || localStorage.getItem('QrId')))
        if (qr.IsCompleted && qr.AdditionalInformations) {
          localStorage.setItem('CardData', qr.AdditionalInformations)
          setTimeout(() => {
            location.reload()
          }, 500)
        } else {
          this.loginStatus = 'createQr'
        }
      } else {
        this.qrListErrorMessage = 'انتخاب کارت اجباریست'
      }
    },
    showQrlist() {
      this.qrListModal = true;
    },
    logout() {
      localStorage.clear();
      location.reload();
    },
    toSmsPanel() {
      window.open('https://app.webone-sms.ir', 'blank')
    }
  },
  watch: {
    mainPageWidth() {
      if (this.screenWidth > this.mainPageWidth) {
        this.$refs.mainPage.style.setProperty('--zoom-level', 1);

      } else {

        console.log(this.mainPageWidth, 'this.mainPageWidth')
        console.log(this.screenWidth, 'this.screenWidth')
        this.$refs.mainPage.style.setProperty('--zoom-level', this.screenWidth / this.mainPageWidth);
        // this.$nextTick(() => {
        //   for (let i = 0; i < moveables.length; i++) {
        //     moveables[i].style.display = 'block'
        //   }
        // })
      }
    },
    widgets: {
      handler() {
        localStorage.setItem('CardData', JSON.stringify({
          ...JSON.parse(localStorage.getItem('CardData')),
          Widgets: this.widgets
        }))
      },
      deep: true,
      immediate: false
    },
    paperSize(val) {
      localStorage.setItem('CardData', JSON.stringify({
        ...JSON.parse(localStorage.getItem('CardData')),
        PaperSize: this.paperSize
      }))
      let paperSize = val.split(' ')
      if (paperSize[0] == 778) {
        this.mainPageWidth = 930
      } else {
        this.mainPageWidth = 810
      }
    },
    pattern() {
      localStorage.setItem('CardData', JSON.stringify({
        ...JSON.parse(localStorage.getItem('CardData')),
        Pattern: this.pattern
      }))
      if (this.pattern.includes('magic.payamakapi')) {
        this.getBase64FromImageUrl(this.pattern).then((base64) => {
          this.patternBase64 = base64
        }).catch((error) => {
          console.error('Error:', error);
        })
      } else {
        this.patternBase64 = ''
      }
    },
    color(val, old) {
      if (old) {
        localStorage.setItem('CardData', JSON.stringify({
          ...JSON.parse(localStorage.getItem('CardData')),
          BackColor: this.color
        }))
      }
    },
    loginStatus() {
      localStorage.setItem('LoginStatus', btoa(this.loginStatus));
    },
    countDown() {
      if (this.loginStatus === 'sendOtp') {
        localStorage.setItem('CountDown', this.countDown);
      } else {
        localStorage.removeItem('CountDown');
      }
    },

    qrColorValue() {
      this.qrShowBox = this.qrColorValue;
    },
    qrBackgroundValue() {
      this.qrShowBackBox = this.qrBackgroundValue;
    },
    mobile(val, old) {
      if (val.length > 11) {
        this.mobile = old
      }
    },
    qrId() {
      localStorage.setItem('QrId', this.qrId);
    },
    qrText() {
      localStorage.setItem('QrText', this.qrText);
    },
    qrList: {
      handler(val) {
        if (val.length)
          localStorage.setItem('QrList', JSON.stringify(this.qrList));
      },
      deep: true,
      immediate: true
    },
    isPreview(val) {
      if (!val) {
        let moveables = document.getElementsByClassName('moveable-control-box')
        for (let i = 0; i < moveables.length; i++) {
          moveables[i].style.display = 'block'
        }
      } else {
        let moveables = document.getElementsByClassName('moveable-control-box')
        for (let i = 0; i < moveables.length; i++) {
          moveables[i].style.display = 'none'
        }
      }
    }
  }
}
</script>

<style scoped>
.is-border {
  border-left: 19px dashed #F2F2F2;
  border-right: 22px dashed #F2F2F2;
  border-top: 23px dashed #F2F2F2;
  border-bottom: 24px dashed #F2F2F2;
}

.align-center {
  display: flex;
  align-items: center;
}

.otp-container {
  display: flex;
  justify-content: center;
}

.form-input {
  margin: 24px 0px;
  position: relative;
}
</style>
